import _ from 'lodash'

export default {
    methods: {
        hasCode(val) {
            return this.notEmpty(val);
        },
        notEmpty(val) {
            return val !== undefined && val != null && val !== '';
        },
        emptyToDefault(val, def) {
            return this.hasCode(val) ? val : def;
        },
        postExport({url, data, name}) {
            this.$store.dispatch("api/post", {
                url: process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/dispatcher/asynchronous",
                data: {
                    requestUrl: url,
                    requestParam: data,
                    reportName: name
                }
            }, {
                root: true
            }).then(() => this.$message.success("操作成功"));
        },
        pushAll(source, target) {
            for (let item of source) {
                target.push(item);
            }
        },
        copyObj2Obj(source, target, force = false) {
            let temp = this.deepCopyObj(source);
            for (let key in temp) {
                if (force || !target[key]) {
                    target[key] = temp[key];
                }
            }
        },
        deepCopyObj(source) {
            return _.cloneDeep(source);
        },
        genNonDuplicateID(randomLength) {
            return Number(Math.random().toString().substring(3, randomLength + 3) + Date.now()).toString(36)
        },
        async downloadWithHeader(url, fileName, requestFinish = () => {
        }, method = 'GET', body = null) {
            let config = {
                method: method,
                headers: new Headers({
                    Authorization: localStorage['em_sso_token'],
                    "Content-Type": "application/json",
                }),
            }
            if (method === 'POST') {
                config.body = JSON.stringify(body);
            }
            // 成功只由「拿到 blob 并触发了 <a download> 点击」这条路径显式给出;
            // 其余任何路径(fetch reject、非 2xx、读流中断)都是失败。
            let success = false;
            let errorMsg;
            let blobUrl = null;
            try {
                let res = await fetch(url, config);
                if (res.ok) {
                    let data = await res.blob();
                    blobUrl = window.URL.createObjectURL(data);
                    let downEle = document.createElement('a');
                    downEle.href = blobUrl;
                    downEle.setAttribute('download', fileName);
                    document.body.appendChild(downEle);
                    downEle.click();
                    downEle.remove();
                    success = true;
                } else {
                    // 失败响应体是 EmBaseResultVo JSON,取 message 供调用方展示具体失败原因;
                    // 网关 HTML 错误页/空 body 解析不出 JSON 时不带 message
                    try {
                        let resBody = await res.json();
                        errorMsg = resBody && resBody.message;
                    } catch (ignored) {
                        errorMsg = undefined;
                    }
                }
            } catch (e) {
                // fetch 本身 reject(断网、连接重置、CORS、DNS)或 blob 读流中断
                errorMsg = e && e.message;
            } finally {
                if (blobUrl != null) {
                    // 部分浏览器在 click() 之后才真正去取 blob,延迟释放避免大文件下载被掐断
                    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
                }
            }
            // 放在 try/catch 之外,保证恰好回调一次:
            // 回调自身抛错不会再被 catch 捕获而重复触发,任何提前 return 也不会漏掉
            requestFinish(success, errorMsg);
        },

        getSearchReg(str) {
            return new RegExp(".*" + str + ".*", "i");
        },

        getRefEl(ref) {
            let temp = this.$refs[ref];
            if (temp && temp instanceof Array && temp[0]) {
                return temp[0];
            } else {
                return temp;
            }
        },

        _toMapList(list, key) {
            let map = new Map();
            if (list) {
                list.forEach(item => {
                    let k = item[key];
                    if (k) {
                        if (map.has(k)) {
                            map.get(k).push(item);
                        } else {
                            map.set(k, [item]);
                        }
                    }
                });
            }
            return map;
        },

        getUrlTokenStr(firstParam = false) {
            return (firstParam ? '?' : '&') + "token=" + localStorage['em_sso_token'];
        },

        _mapToObject(map) {
            return [...map.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
        },

        _strLengthZh2(str) {
            if (!this.hasCode(str)) {
                return 0;
            }
            let len = 0;
            for (let i = 0; i < str.length; i++) {
                if ((str.charCodeAt(i) & 0xff00) !== 0) {
                    len++;
                }
                len++;
            }
            return len;
        },
        _baseUrl(entity) {
            return `${this.$store.state[entity].baseModuleUrl}/${entity}/`;
        },
        _arrayValueCount(list, key, addPredicate = item => true) {
            let temp = {};
            for (let item of list) {
                let k = item[key];
                if (k && addPredicate(item)) {
                    if (temp[k]) {
                        temp[k]++;
                    } else {
                        temp[k] = 1;
                    }
                }
            }
            return temp;
        },
        _camelToTitleCase(str) {
            return str.replace(/([A-Z])/g, ' $1') // 将大写字母前添加空格
                .replace(/^./, str => str.toUpperCase()) // 将首字母大写
                .trim();
        },
        _translateDict(code, value) {
            return this.$store.getters['dictionaryEnumStore/translate'](code, value);
        },
        _generateDownloadUrl(val) {
            return process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=" + val;
        },
        _getQueryParam(url, param) {
            const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)');
            const results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    }
}
